import { required } from '@jfs/ui-new'
import { returnRegexSchema } from '@jfs/ui/src/util/validations'
import { convertToTwoDigit } from '@jfs/utils'
import Config from 'react-native-config'
import { TextInputWithLabelOnBorder } from '../comps/TextInputWithLabelOnBorder'
import { Dropdown } from '../screens/BillPayments/AuthInput/Dropdown'
import { TextInputWithLabelOnBorderWrapper } from '../screens/BillPayments/AuthInput/TextInputWithLabelOnBorderWrapper'
import { Colors } from './util'

const REACT_APP_BASE_URL = Config.REACT_APP_BASE_URL

const { REACT_APP_JFS_PUBLIC_KEY = '', REACT_APP_REDIRECT_URL = '' } = (window?._env_ ?? {})

export const BillerCategoryMasterId = {
  PrepaidMobile: 100001,
  PostpaidMobile: 100002,
  DTH: 100003,
  PrepaidDatacard: 100004,
  PostpaidDatacard: 100005,
  Electricity: 100006,
  Gas: 100007,
  Insurance: 100008,
  Landline: 100009,
  Broadband: 100010,
  Charity: 100011,
  Subscription: 100012,
  Water_Tax: 100013,
  JioPayments: 100014,
  JioPostpaid: 100015,
  MunicipalTax: 100016,
  Housing_Societies: 100017,
  Mutual_Fund: 100019,
  IndiaTodayBillerMasterId: 100115,
  Toll: 200014,
  Cylinder_Booking: 100020,
  FastagRecharge: 100021,
  LoanRepayment: 100022,
  EducationFee: 100018,
  GiftCard: 100023,
  GooglePay: 100024,
  CabelTv: 100025,
  Hospital: 100026,
  CreditCard: 100027,
  Clubs: 100028,
  RecurringDeposit: 100029,
  Rentals: 100030,
}

export enum ScreenType {
  App = 'App',
  Buy = 'Buy',
  Vault = 'Vault',
  Sell = 'Sell',
  AccountSettlement = 'AccountSettlement',
  NewAccountSettlement = 'NewAccountSettlement',
  AllCatalog = 'AllCatalog',
  CatalogueDetails = 'CatalogueDetails',
  TransactionHistory = 'TransactionHistory',
  Delivery = 'Delivery',
  TransactionDetails = 'TransactionDetails',
  DeliveryAddress = 'DeliveryAddress',
  Review = 'Review',
  MPin = 'Mpin',
  TransactionProcessing = 'TransactionProcessing',
  TxnProcessing = 'TxnProcessing',
  TxnPaymentStatus = 'TxnPaymentStatus',
  UserSupport = 'UserSupport',
  Categories = 'Categories',
  QuestionAndAnswer = 'QuestionAndAnswer',
  NetBanking = 'NetBanking',
  Offers = 'Offers',
  OfferDetails = 'OfferDetails',
  PaymentModes = 'PaymentModes',
  PaymentInstrument = 'PaymentInstrument',
  TermsNConditions = 'TermsNConditions',
  AddNewAddress = 'AddNewAddress',
  NewCard = 'NewCard',
  Settings = 'Settings',
  ApiList = 'ApiList',
  ApiDetails = 'ApiDetails',
  Video = 'Video',
  ResetMpin = 'ResetMpin',
  OperatorDetail = 'Detail',
  AuthInput = 'AuthInput',
  BillFetchDetail = 'BillFetch',
  LandingView = 'LandingView',
  PaymentView = 'PaymentView',
  OperatorList = 'OperatorList',
  JioPayment = 'JioPayment',
  TollRecharge = 'TollRecharge',
  HotelHome = 'HotelHome',
  HotelSearch = 'HotelSearch',
  ReviewRatings = 'ReviewRatings',
  HotelDetail = 'HotelDetail',
  HotelGSTInfo = 'HotelGSTInfo',
  RoomDetail = 'RoomDetail',
  HotelFilters = 'HotelFilters',
  Calendar = 'Calendar',
  AboutHotel = 'AboutHotel',
  MyBookings = 'MyBookings',
  BookingDetails = 'BookingDetails',
  CancelBooking = 'CancelBoooking',
  UserReview = 'UserReview',
  Maps = 'Maps',
  HotelReview = 'HotelReview',
  AmenitiesList = 'AmenitiesList',
  HotelGuestInfo = 'HotelGuestInfo',
  TnC = 'TnC',
  FavouriteList = 'FavouriteList',
  Processing = 'Processing',
  HotelCheckIn = 'Check in date',
  HotelCheckOut = 'Check out date',
  MyBills = 'MyBills',
  ManageBills = 'ManageBills',
  MyCalender = 'MyCalender',
  Recharge = 'Mobile',
  Plans = 'Plans',
  PlanList = 'PlanList',
  PhysicalBill = 'PhysicalBill',
  TransactionList = 'TransactionList',
}

export const EARLY_PAY_NOTICE =
  'Note: Paying this bill allows us to fetch your current and future bills so that you can view and pay them.'

export const PAYMYBILL = {
  POLLING_MESSAGE: 'Fetching updated status...',
  PENDING_MESSAGE: 'Unable to fetch updated status. \nPlease check your transaction history in sometime',
  ERROR_MESSAGE: 'Error fetching updated status. \nPlease check your transaction history in sometime',
  SUCCESS_TITLE: 'You have successfully made the payment',
  SUCCESS_DESC:
    'While payment you made will be processed immediately, it can take upto 3 days for service provider to update details',
  FAILED_TITLE: 'Your transaction has failed',
  FAILED_DESC:
    'Note: If money is debited from your account, it will be automatically refunded to source within 3-5 working days',
  PENDING_TITLE: 'Awaiting confirmation',
  PENDING_DESC:
    'We have submitted your bill payment details and yet to receive confirmation from biller. We will notify you once status is confirmed',
  billFetchError: 'Sorry, we are unable to process your request right now. Please try after some time.',
  Add_BILLER_TITLE: 'Add Biller',
  ADD_BILLER_SUBTITLE: 'YOUR ACCOUNT WILL BE ADDED TO MY BILLS',
  NOTIFICATION_INFO_ALERT_MESSAGE_1:
    'You will receive alerts for future bills & timely reminder for payments. You can turn off notification from ‘My Bills’ Section',
  NOTIFICATION_INFO_ALERT_MESSAGE_2:
    'Get Timely alert! We will send alerts for further bills & timely reminders. You can always turn off notifications from ‘My Bills’ section',
  NOTIFICATION_ALERT_TITLE: 'Get Timely alert!',
  NICKNAME_ALERT_MESSAGE:
    'A Nickname helps you identify bills for future transactions. Nickname can be edited from My Bills section',
  NICK_NAME_DISPLAY_NAME: 'Nick Name',
  AMOUNT_DISPLAY_NAME: 'Amount',
  NICK_NAME_PLACE_HOLDER: 'Enter Nick name(Optional)',
  AMOUNT_PLACE_HOLDER: 'Enter Amount',
  BILL_REGISTRATION_SUBTITILE:
    'We have recorded your bill details and will notify you the moment your bill is ready to be paid.',
}
const defaultMetaInfo = {
  isPostPaid: false,
  operatorScreen: ScreenType.OperatorList,
  billNote: EARLY_PAY_NOTICE,
  transactionSuccessNote: PAYMYBILL.SUCCESS_DESC,
  icon: 'BillPaymentRupeeIcon', // default icon
  title: '',
}

export const getCategoryMetaData = (id: any) => {
  return categoryMetaData[id] ?? defaultMetaInfo
}
export const categoryMetaData = {
  [BillerCategoryMasterId.PrepaidMobile]: {
    ...defaultMetaInfo,
    operatorScreen: ScreenType.Recharge, // TODO: add biller and verify the biller
    // billNote: '',
    transactionSuccessNote: '',
    icon: 'MOBILE_ICON',
    title: 'Prepaid Mobile',
  },
  [BillerCategoryMasterId.PostpaidMobile]: {
    ...defaultMetaInfo,
    //operatorScreen: ScreenType.Recharge, // TODO: working with other UI flowa
    isPostPaid: true,
    icon: 'MOBILE_ICON',
    title: 'Postpaid Mobile',
  },
  [BillerCategoryMasterId.DTH]: {
    ...defaultMetaInfo,
    // billNote: '',
    transactionSuccessNote: '',
    icon: 'DTH_ICON',
    title: 'DTH',
  },
  [BillerCategoryMasterId.PrepaidDatacard]: {
    ...defaultMetaInfo,
    operatorScreen: ScreenType.Recharge,
    // billNote: '',
    transactionSuccessNote: '',
    icon: 'DATA_CARD_ICON',
    title: 'Prepaid Datacard',
  },
  [BillerCategoryMasterId.PostpaidDatacard]: {
    ...defaultMetaInfo,
    operatorScreen: ScreenType.Recharge,
    isPostPaid: true,
    icon: 'DATA_CARD_ICON',
    title: 'Postpaid Datacard',
  },
  [BillerCategoryMasterId.Electricity]: {
    ...defaultMetaInfo,
    icon: 'ELECTRICITY_ICON',
    title: 'Electricity',
  },
  [BillerCategoryMasterId.Gas]: {
    ...defaultMetaInfo,
    icon: 'GAS_ICON',
    title: 'Gas',
  },
  [BillerCategoryMasterId.Cylinder_Booking]: {
    ...defaultMetaInfo,
    icon: 'CYLINDER_ICON',
    title: 'Cylinder Booking',
    billNote:
      'Note: We handle only payment processing. Delivery of the cylinder or any issues around it, will be handled by your distributor / agency.',
    transactionSuccessNote:
      'Your cylinder will be delivered by your distributor. In case of any delivery issues, please check with your distributor using LPG booking id.',
  },
  [BillerCategoryMasterId.Insurance]: {
    ...defaultMetaInfo,
    icon: 'INSURANCE_ICON',
    title: 'Insurance',
  },
  [BillerCategoryMasterId.Landline]: {
    ...defaultMetaInfo,
    icon: 'LANDLINE_ICON',
    title: 'Landline',
  },
  [BillerCategoryMasterId.Broadband]: {
    ...defaultMetaInfo,
    icon: 'BROADBAND_ICON',
    title: 'Broadband',
  },
  [BillerCategoryMasterId.Charity]: {
    ...defaultMetaInfo,
    // billNote: '',
    transactionSuccessNote: '',
    icon: 'CHARITY_ICON',
    title: 'Charity',
  },
  [BillerCategoryMasterId.Subscription]: {
    ...defaultMetaInfo,
    // billNote: '',
    transactionSuccessNote: '',
    icon: 'SUBSCRIPTION_ICON',
    title: 'Subscription',
  },
  [BillerCategoryMasterId.Water_Tax]: {
    ...defaultMetaInfo,
    icon: 'WATER_ICON',
    title: 'Water Tax',
  },
  [BillerCategoryMasterId.Housing_Societies]: {
    ...defaultMetaInfo,
    icon: 'HOUSING_ICON',
    title: 'Housing Societies',
  },
  [BillerCategoryMasterId.MunicipalTax]: {
    ...defaultMetaInfo,
    icon: 'TAX_ICON',
    title: 'Municipal Tax',
  },
  [BillerCategoryMasterId.Mutual_Fund]: {
    ...defaultMetaInfo,
    icon: 'MUTUAL_FUND_ICON',
    title: 'Mutual Fund',
  },
  [BillerCategoryMasterId.JioPayments]: {
    ...defaultMetaInfo,
    //operatorScreen: ScreenType.JioPayment,
    icon: 'JIO_ICON',
    title: 'Jio Payments',
  },
  [BillerCategoryMasterId.JioPostpaid]: {
    ...defaultMetaInfo,
    //operatorScreen: ScreenType.JioPayment,
    icon: 'JIO_ICON',
    title: 'Jio Postpaid',
  },
  [BillerCategoryMasterId.Toll]: {
    ...defaultMetaInfo,
    //operatorScreen: ScreenType.TollRecharge,
    icon: 'TOLL_ICON',
    title: 'Toll',
  },
  [BillerCategoryMasterId.FastagRecharge]: {
    ...defaultMetaInfo,
    icon: 'FAST_TAG_ICON',
    title: 'Fastag Recharge',
  },
  [BillerCategoryMasterId.EducationFee]: {
    ...defaultMetaInfo,
    icon: 'EDUCATION_ICON',
    title: 'Education Fees',
  },
  [BillerCategoryMasterId.GiftCard]: {
    ...defaultMetaInfo,
    icon: 'GIFT_CARD_ICON',
    title: 'Gift Card',
  },
  [BillerCategoryMasterId.GooglePay]: {
    ...defaultMetaInfo,
    icon: 'GOOGLE_PLAY_ICON',
    title: 'Google Pay',
  },
  [BillerCategoryMasterId.CabelTv]: {
    ...defaultMetaInfo,
    icon: 'CABLE_ICON',
    title: 'Cable TV',
  },
  [BillerCategoryMasterId.LoanRepayment]: {
    ...defaultMetaInfo,
    icon: 'LOAN_ICON',
    title: 'Loan Repayment',
  },
  [BillerCategoryMasterId.Hospital]: {
    ...defaultMetaInfo,
    icon: 'HOSPITALITY_ICON',
    title: 'Hospital',
  },
  [BillerCategoryMasterId.CreditCard]: {
    ...defaultMetaInfo,
    icon: 'CREDIT_CARD_ICON',
    title: 'Credit Card',
  },
  [BillerCategoryMasterId.Clubs]: {
    ...defaultMetaInfo,
    icon: 'CLUBS_ICON',
    title: 'Clubs',
  },
  [BillerCategoryMasterId.Rentals]: {
    ...defaultMetaInfo,
    icon: 'RENTALS_ICON',
    title: 'Rentals',
  },
  [BillerCategoryMasterId.RecurringDeposit]: {
    ...defaultMetaInfo,
    icon: 'RECURRING_DEPOSITS_ICON',
    title: 'Recurring Deposits',
  },
}

export enum TransactionStatus {
  INITIATED = 'Initiated',
  INITIATED_ADD_BILLER = 'Initiated_Add_Biller',
  REGISTERED_BILLER = 'Registered_Biller',
}
export const convertBoolValue = (flagValue: string) => {
  return flagValue === 'Y' ? true : false
}

//const { REACT_APP_JFS_IMAGE_BASE_URL } = window?._env_
const REACT_APP_JFS_IMAGE_BASE_URL = Config.REACT_APP_JFS_IMAGE_BASE_URL
export const getImageUrlPath = (billerLogoPath: any) => {
  if (billerLogoPath === '' || billerLogoPath?.length < 1 || billerLogoPath === undefined) {
    return undefined
  }
  return `${REACT_APP_JFS_IMAGE_BASE_URL}/${billerLogoPath?.toLowerCase()}`
}

export const getBillId = (billerId: number, authenticators: any) => {
  return authenticators.reduce((acc: any, item: any) => `${acc}_${item}`, billerId)
}
export const getStringFromDate = (dateStr: string) => {
  const dateParts = dateStr.split('/') as any

  // month is 0-based, that's why we need dataParts[1] - 1
  return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
}

export function isEmptyString(str: string) {
  return str === undefined || str === null || str.length === 0 || str.match(/^ *$/)
}

export const getDateInfo = (item: any) => {
  let dateInfo = ''
  const isDateAvailable = isEmptyString(item?.lastPaidDate)
  if (item?.status) {
    const currentDate = new Date()

    // const billDueDate = getStringFromDate(item.txnMetaData?.bill?.dueDate ?? '')
    const billDueDate = getStringFromDate(item?.dueDate ?? '')
    if (item.status === 'SCHEDULED') {
      dateInfo = `Debit date: ${item?.scheduledDebitDate}`
    } else if (item.status === 'U' && currentDate <= billDueDate) {
      dateInfo = `Due on: ${item?.dueDate ?? ''}`
    } else if (item.status === 'U' && currentDate >= billDueDate) {
      if (item.lastPaymentGreaterThanBillCreatedDate) {
        if (item.lastPaidDate === null) {
          dateInfo = item.createdDate ? `Biller Added : ${item.createdDate ?? ''}` : 'Biller Added'
        } else {
          if (isDateAvailable) {
            return
          } else {
            dateInfo = `Last Paid : ${item.lastPaidDate ?? ''}`
          }
        }
      }
      dateInfo = `Expired Date : ${item.dueDate ?? ''}`
    } else {
      if (item.lastPaidDate === null) {
        dateInfo = item.createdDate ? `Biller Added : ${item.createdDate ?? ''}` : 'Biller Added'
      } else {
        if (isDateAvailable) {
          return
        } else {
          dateInfo = `Last Paid : ${item.lastPaidDate ?? ''}`
        }
      }
    }
  } else {
    if (item.lastPaidDate === null) {
      dateInfo = item.createdDate ? `Biller Added : ${item.createdDate ?? ''}` : 'Biller Added'
    } else {
      if (isDateAvailable) {
        return
      } else {
        dateInfo = `Last Paid : ${item.lastPaidDate ?? ''}`
      }
    }
  }

  return dateInfo
}

export const calculateDays = (startDate: any, endDate: any) => {
  // Format - calculateDays('November 02, 2019', 'December 04, 2019')
  const fromDate = new Date(startDate)

  const toDate = new Date(endDate)

  const diffInDates = toDate.getTime() - fromDate.getTime()

  const diffInDays = diffInDates / (1000 * 3600 * 24)
  return diffInDays
}

export const getNoticeInfo = (item: any) => {
  const noteObj = {
    noteText: '',
    textColor: 'BLACK',
  }

  if (item?.status && item?.status !== 'Unregistered' && item?.status !== 'Registered') {
    const currentDate: any = new Date()
    const billDueDate: any = getStringFromDate(item?.dueDate)
    const dayDiff = Math.round(calculateDays(currentDate, billDueDate))

    // const totalDueAmount = item.amount

    if (item.status === 'SCHEDULED') {
      /*
      const walletBalenceAmount = 100

      if (walletBalenceAmount < totalDueAmount && dayDiff === 0) {
        noteObj.noteText = 'Your balance is less than debit amount!'
        noteObj.textColor = 'ERROR'
      } else if (walletBalenceAmount < totalDueAmount) {
        noteObj.noteText = 'Please maintain sufficient balance!'
        noteObj.textColor = 'ERROR'
      } else */
      if (dayDiff === 0) {
        noteObj.noteText = 'Auto debit today'
        noteObj.textColor = 'GREEN'
      } else if (dayDiff === 1) {
        noteObj.noteText = 'Auto debit tomorrow'
        noteObj.textColor = 'GREEN'
      } else if (dayDiff > 1) {
        noteObj.noteText = `Auto debit in ${dayDiff} days`
        noteObj.textColor = 'GREEN'
      }
    } else if (item?.status === 'U' && currentDate <= billDueDate) {
      if (dayDiff === 0) {
        noteObj.noteText = 'Due today!'
        noteObj.textColor = 'GREEN'
      } else if (dayDiff === 1) {
        noteObj.noteText = 'Due today!'
        noteObj.textColor = 'ERROR'
      } else {
        noteObj.noteText = `${dayDiff} days to go`
        noteObj.textColor = 'GREEN'
      }
    }
  }
  return noteObj
}

export const IS_DEVELOPMENT_MODE = REACT_APP_BASE_URL?.includes('http://10.140.139.153:9080')

export const keyExtractorData = ({ }, index: number) => index.toString()

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
const dayOfWeekNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const simpleDateFormat = (date: Date, patternStr: string) => {
  if (!patternStr) {
    patternStr = 'M/d/yyyy'
  }
  const newDate = new Date(date)
  if (!newDate) {
    return 'NA'
  }
  let day: any = date.getDate()
  let month: any = date.getMonth()
  let year: any = date.getFullYear()
  let hour: any = date.getHours()
  let minute: any = date.getMinutes()
  let second: any = date.getSeconds()
  let miliseconds: any = date.getMilliseconds()
  let EEEE: any = dayOfWeekNames[date.getDay()] ?? ''
  let h: any = hour % 12
  let hh: any = twoDigitPad(h)
  let HH: any = twoDigitPad(hour)
  let mm: any = twoDigitPad(minute)
  let ss: any = twoDigitPad(second)
  let aaa: any = hour < 12 ? 'AM' : 'PM'
  let EEE: any = EEEE.substr(0, 3)
  let dd: any = twoDigitPad(day)
  let M: any = month + 1
  let MM: any = twoDigitPad(M)
  let MMMM: any = monthNames[month] ?? ''
  let MMM: any = MMMM.substr(0, 3)
  let yyyy: any = year + ''
  let yy: any = yyyy.substr(2, 2)

  // checks to see if month name will be used
  patternStr = patternStr
    .replace('hh', hh)
    .replace('h', h)
    .replace('HH', HH)
    .replace('H', hour)
    .replace('mm', mm)
    .replace('m', minute)
    .replace('ss', ss)
    .replace('s', second)
    .replace('S', miliseconds)
    .replace('dd', dd)
    .replace('d', day)

    .replace('EEEE', EEEE)
    .replace('EEE', EEE)
    .replace('yyyy', yyyy)
    .replace('yy', yy)
    .replace('aaa', aaa)
  if (patternStr.indexOf('MMM') > -1) {
    patternStr = patternStr.replace('MMMM', MMMM).replace('MMM', MMM)
  } else {
    patternStr = patternStr.replace('MM', MM).replace('M', M)
  }
  return patternStr
}

const twoDigitPad = (num) => (num < 10 ? '0' + num : num)

export const SUCCESS = 'SUCCESS'
const PENDING = 'PENDING'
const FAILURE = 'FAILED'
export const REFUND_INITIATED = 'REFUND_INITIATED'
export const PAYMENT_RECEIVED = 'PAYMENT_RECEIVED'
export const getStatusFromOrderApi = (orderData: any) => {
  const orderStatus = orderData?.status?.toUpperCase()
  const fulfilmentStatus = orderData?.fulfilment?.status?.toUpperCase()
  const paymentStatus = orderData?.payment?.status?.toUpperCase()

  if (paymentStatus === SUCCESS) {
    if (orderStatus === FAILURE) {
      return FAILURE // TODO: confirm with product
    } else if (orderStatus === PAYMENT_RECEIVED && fulfilmentStatus === SUCCESS) {
      return SUCCESS
    } else if (fulfilmentStatus === SUCCESS) {
      return SUCCESS
    } else if (fulfilmentStatus === PENDING) {
      return PENDING
    } else if (fulfilmentStatus === FAILURE && orderStatus === REFUND_INITIATED) {
      return FAILURE
    } else if (fulfilmentStatus === FAILURE) {
      return FAILURE
    }
  } else if (paymentStatus === FAILURE) {
    return FAILURE
  } else if (paymentStatus === PENDING) {
    return PENDING
  }
}

export const amountDecimalCorrection = (amount: any) => {
  const amountString = amount?.toString()
  return amountString?.split('.')?.[1]?.length === 1 ? amountString + '0' : amountString
}

const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function hyphenSeparatedDate(date: Date, format?: string) {
  let formattedDate = ''
  switch (format) {
    case 'DD-MM-YYYY':
    case 'dd-mm-yyyy':
      formattedDate = `${convertToTwoDigit(date.getDate())}-${convertToTwoDigit(
        date.getMonth() + 1,
      )}-${date.getFullYear()}`
      break
    case 'dd MMM':
      formattedDate = `${date.getDate()} ${shortMonths[date.getMonth()]}`
      break
    case 'dd-mm-yyyy hh:mm:ss':
      formattedDate = `${convertToTwoDigit(date.getDate())}-${convertToTwoDigit(
        date.getMonth() + 1,
      )}-${date.getFullYear()}  ${convertToTwoDigit(date.getHours())}:${convertToTwoDigit(
        date.getMinutes(),
      )}:${convertToTwoDigit(date.getSeconds())}`
      break
    default:
      formattedDate = `${date.getFullYear()}-${convertToTwoDigit(date.getMonth() + 1)}-${convertToTwoDigit(
        date.getDate(),
      )}`
      break
  }
  return formattedDate
}
const NOT_ALLLOWED = ''
export const getNoteText = (id: number, msg = '', notAllowed = false, isAddBillerFlow = false) => {
  if (isAddBillerFlow) {
    return ''
  }
  if (msg !== '' && msg !== null) {
    return msg
  }
  if (notAllowed) {
    return NOT_ALLLOWED
  }
  return getCategoryMetaData(id).billNote
}

const getDropDownListArray = (pattern: string) => {
  let res = pattern.replace('^(', '')
  res = res.replace(')$', '')
  const arr = res.split('|')

  return arr.map((item, index) => {
    return {
      id: (index + 1).toString(),
      text: item,
    }
  })
}

export const getKeyboardType = (dataType: string) => {
  if (dataType === 'E') {
    return 'email-address'
  } else if (dataType === 'N') {
    return 'number-pad'
  } else if (dataType === 'F') {
    return 'decimal-pad'
  } else if (dataType === 'NV') {
    return 'name-phone-pad'
  }
  return 'default'
}

export const getOperatorField = (dataItem: any, index: number, authLength: number, inputRef: any) => {
  if (dataItem.dataType === 'L') {
    const dropDownRet: any = {
      ComponentName: Dropdown,
      component: Dropdown,
      fieldName: dataItem.displayName,
      isFirstObj: index === 0,
      isLastObj: index === authLength - 1,
      data: getDropDownListArray(dataItem.fieldValidationPattern),
      label: dataItem.displayName,
      validationSchema: required,
      showBottomLine: false,
      height: 48,
      labelFontSize: 14,
      selectionColor: Colors.PRIMARY,
      fontSize: 16,
      lineHeight: 20,
      verticalSpacing: 10,
    }
    if (index === 0) {
      dropDownRet.innerRef = inputRef
    }

    return dropDownRet
  }

  const isMobileNumberField =
    dataItem?.displayName?.toLowerCase()?.includes('telephone') ||
    dataItem?.displayName?.toLowerCase()?.includes('mobile')
  const retData: any = {
    ComponentName: TextInputWithLabelOnBorderWrapper,
    component: TextInputWithLabelOnBorder,
    isFirstObj: index === 0,
    isLastObj: index === authLength - 1,
    fieldName: dataItem.displayName,
    validationSchema: returnRegexSchema(new RegExp(dataItem.fieldValidationPattern), dataItem.fieldErrorMessage),
    showBottomLine: false,
    keyboardType: getKeyboardType(dataItem.dataType),
    label: dataItem.displayName,
    // placeholder: dataItem.displayName,
    testID: `operatorField${index}`,
    height: 48,
    labelFontSize: 14,
    maxLength: isMobileNumberField ? 10 : 60,
    selectionColor: Colors.PRIMARY,
    fontSize: 16,
    lineHeight: 20,
  }
  if (index === 0) {
    retData.innerRef = inputRef
  }

  return retData
}

export const getAmountDataWithUniCode = (amount: any) => {
  if (amount) {
    return amount === 0 ? '' : `₹ ${amount.toString()}`
  }
  return ''
}

export const operatorKeyExtractor = (item: any, index: number) => `${item.billerType}_${item.billerMasterId}_${index}`

export const isMaxDateRangeSelected = (selectedDateInfo) => {
  const selectedDateTimeInMillis = new Date(selectedDateInfo?.fromDate)?.getTime()
  const today = new Date(Date.now()).getTime()
  const oneDay = 24 * 60 * 60 * 1000
  const diff = Math.floor((today - selectedDateTimeInMillis) / oneDay)
  return diff > 180
}

export const categoryOrder = [
  { Recharge: 'Recharges' },
  { Utilities: 'Utilities' },
  { Finances: 'Financial Services' },
  { Others: 'Other Services' },
]
